import type {Content, ImageField, KeyTextField, LinkField, RichTextField} from '@prismicio/client'
import {useMemo} from 'react'

const categories = ['accounting', 'hris', 'sso', 'expenses'] as const

interface Integration {
  name: KeyTextField
  description: KeyTextField
  logo: ImageField
  link: LinkField
  link_url?: LinkField
}

export interface CategoryIntegrations {
  title: KeyTextField | RichTextField
  integrations: Integration[]
}

const useGetIntegrations = (
  sliceContent: Content.IntegrationsContainerSliceDefaultPrimary | Content.IntegrationsContainerSliceV2Primary,
): CategoryIntegrations[] =>
  useMemo(() => {
    const result = categories.map((category) => ({title: category, integrations: [] as Integration[]}))

    let field: keyof Content.IntegrationsContainerSliceDefaultPrimary

    for (field in sliceContent) {
      const [category, resultKey] = field.split('_') as [(typeof categories)[number], 'title' | 'integrations']

      if (categories.includes(category)) {
        // @ts-expect-error -- TS doesn't know that `field` is a key of `Integration`
        result[categories.indexOf(category)][resultKey] = sliceContent[field]
      }
    }

    // Normalize link_url to link field for consistency across all categories
    return result.map((category) => ({
      ...category,
      integrations: category.integrations.map((integration) => ({
        ...integration,
        link: integration.link || integration.link_url || {},
      })),
    }))
  }, [sliceContent])

export default useGetIntegrations
